export default __webpack_public_path__ + "static/img_desktop_2-86927866a3119f3e01affc8c39a15a2d.jpg";